// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-ion-bmw-portal-1.5.0." + {"70":"505b5b3166d60a20","214":"12d709f4ce653ccb","374":"7d8f75aee478ef53","432":"250dc97c226c49e8"}[chunkId] + ".js";
};